import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { queryKeys } from "@/constants";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

interface CloseTraceResponse {
  success: boolean;
  closure?: {
    id: string;
    workspace_id: number;
    trace_id: string;
    status: string;
    created_at: string;
    updated_at: string;
  };
  message?: string;
}

export const useCloseTrace = (userToken: string, workspaceId: number) => {
  const queryClient = useQueryClient();

  return useMutation<CloseTraceResponse, Error, string>(
    traceId =>
      fetch(ENDPOINTS.close_trace(workspaceId, traceId), {
        method: "POST",
        headers: authHeader(userToken),
      }).then(handleResponse),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.spans]);
        queryClient.invalidateQueries({
          predicate: query =>
            Array.isArray(query.queryKey) && query.queryKey[0] === queryKeys.traces,
        });
      },
    },
  );
};
